"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorAction = exports.RingAssignment = exports.AuditRecord = exports.AUDIT_RECORD_SCHEMA_VERSION = exports.auditPartitionKey = exports.auditRecordId = exports.AuditOperation = exports.EnvelopeIdentity = exports.AuditEnvelope = exports.AUDIT_SCHEMA_VERSION = exports.AuditContext = exports.ActorOrigin = exports.Actor = exports.UnknownActor = exports.KnownActor = exports.CausedBy = exports.ActorType = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../date");
const entity_1 = require("../entity");
const Json = __importStar(require("../json"));
const base_1 = require("./device/class/base");
const common_1 = require("./device/class/common");
exports.NAMESPACE = 'Culligan.Audit';
exports.ActorType = effect_1.Schema.Literal('admin', 'device', 'service', 'system', 'user').annotations({
    identifier: `${exports.NAMESPACE}.ActorType`,
});
exports.CausedBy = effect_1.Schema.Struct({
    changeFeedFrom: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Source container whose change feed triggered the write',
    }),
}).annotations({ identifier: `${exports.NAMESPACE}.CausedBy` });
const actorFields = {
    causedBy: effect_1.Schema.optionalWith(exports.CausedBy, { exact: true }),
    displayName: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
    tenantId: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
};
exports.KnownActor = effect_1.Schema.Struct({
    ...actorFields,
    id: effect_1.Schema.NonEmptyString,
    type: exports.ActorType,
}).annotations({ identifier: `${exports.NAMESPACE}.KnownActor` });
exports.UnknownActor = effect_1.Schema.Struct({
    ...actorFields,
    id: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
    type: effect_1.Schema.Literal('unknown'),
}).annotations({ identifier: `${exports.NAMESPACE}.UnknownActor` });
exports.Actor = effect_1.Schema.Union(exports.KnownActor, exports.UnknownActor).annotations({
    identifier: `${exports.NAMESPACE}.Actor`,
    description: 'The principal a write is attributed to',
});
exports.ActorOrigin = effect_1.Schema.Literal('change-feed', 'dps', 'http', 'iot-hub', 'script', 'timer').annotations({
    identifier: `${exports.NAMESPACE}.ActorOrigin`,
    description: 'Entry point that resolved the actor',
});
exports.AuditContext = effect_1.Schema.Struct({
    actor: exports.Actor,
    actorOrigin: exports.ActorOrigin,
    requestId: effect_1.Schema.NonEmptyString,
}).annotations({
    identifier: `${exports.NAMESPACE}.AuditContext`,
    description: 'Caller-supplied attribution required by every auditable write',
});
exports.AUDIT_SCHEMA_VERSION = 1;
exports.AuditEnvelope = effect_1.Schema.Struct({
    ...exports.AuditContext.fields,
    schemaVersion: effect_1.Schema.Literal(exports.AUDIT_SCHEMA_VERSION),
    timestamp: date_1.DateFromUtcIsoDateString,
}).annotations({
    identifier: `${exports.NAMESPACE}.AuditEnvelope`,
    description: 'Actor metadata embedded as `__audit` on every audited source document',
});
exports.EnvelopeIdentity = exports.AuditEnvelope.pipe(effect_1.Schema.pick('requestId', 'timestamp')).annotations({
    identifier: `${exports.NAMESPACE}.EnvelopeIdentity`,
    description: 'What the freshness rule compares: one audited write per requestId and timestamp',
});
exports.AuditOperation = effect_1.Schema.Literal('create', 'delete', 'update').annotations({
    identifier: `${exports.NAMESPACE}.AuditOperation`,
    description: 'A soft delete is a delete: hard deletes never reach the change feed',
});
/**
 * The idempotency key: re-processing a change upserts the same record. `_ts` has
 * one-second resolution, so two versions of a document written within the same
 * second share a key and the later one wins, as the latest-version feed itself
 * would coalesce them.
 */
const auditRecordId = ({ sourceContainer, sourceDocId, sourceTs }) => `${sourceContainer}:${sourceDocId}:${sourceTs}`;
exports.auditRecordId = auditRecordId;
/** Every record of one source document lives in one logical partition (IOTCI-342 lookup). */
const auditPartitionKey = ({ sourceContainer, sourceDocId, }) => `${sourceContainer}:${sourceDocId}`;
exports.auditPartitionKey = auditPartitionKey;
exports.AUDIT_RECORD_SCHEMA_VERSION = 1;
exports.AuditRecord = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    partitionKey: effect_1.Schema.NonEmptyString,
    schemaVersion: effect_1.Schema.Literal(exports.AUDIT_RECORD_SCHEMA_VERSION),
    sourceContainer: effect_1.Schema.NonEmptyString,
    sourceDocId: effect_1.Schema.NonEmptyString,
    sourceTs: effect_1.Schema.Int,
    operation: exports.AuditOperation,
    actor: exports.Actor,
    actorOrigin: effect_1.Schema.optionalWith(exports.ActorOrigin, { exact: true }),
    requestId: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }),
    timestamp: effect_1.Schema.propertySignature(date_1.DateFromUtcIsoDateString).annotations({
        description: 'When the change happened: the envelope timestamp, else the source `_ts`',
    }),
    staleEnvelope: effect_1.Schema.optionalWith(exports.EnvelopeIdentity, { exact: true }).annotations({
        description: 'The envelope a stale write carried forward, so the next bypass write is caught too',
    }),
    capturedAt: date_1.DateFromUtcIsoDateString,
    maskCatalogVersion: effect_1.Schema.Int,
    beforeSnapshot: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(Json.Record)).annotations({
        description: "The previous record's afterSnapshot; null on the first record of a document",
    }),
    afterSnapshot: effect_1.Schema.propertySignature(Json.Record).annotations({
        description: 'The masked source document, without Cosmos system properties',
    }),
    changedPaths: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.Array(effect_1.Schema.String))).annotations({
        description: 'Sorted RFC 6901 pointers that differ from beforeSnapshot, or every leaf without one',
    }),
})
    .pipe(effect_1.Schema.filter(record => record.id === (0, exports.auditRecordId)(record), {
    message: () => 'id must be <sourceContainer>:<sourceDocId>:<sourceTs>',
}), effect_1.Schema.filter(record => record.partitionKey === (0, exports.auditPartitionKey)(record), {
    message: () => 'partitionKey must be <sourceContainer>:<sourceDocId>',
}))
    .annotations({
    identifier: `${exports.NAMESPACE}.AuditRecord`,
    description: 'One audited change to a source document, as stored in audit_changes',
});
exports.RingAssignment = effect_1.Schema.Struct({
    ...entity_1.BaseTimestampedEntity.fields,
    id: effect_1.Schema.NonEmptyString,
    userId: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Partition key of history_users_api_actions: always `actor.id`',
    }),
    actor: effect_1.Schema.propertySignature(exports.KnownActor).annotations({
        description: 'The operator, by Entra object id: an admin, or a service when a pipeline runs the tooling',
    }),
    reason: effect_1.Schema.NonEmptyString,
    action: effect_1.Schema.Literal('device.ring.set'),
    deviceId: common_1.Id,
    previousRing: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String)).annotations({
        description: 'The stored value before the write, loose like the persisted field',
    }),
    ring: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(base_1.Ring)).annotations({
        description: 'The ring written; null means the assignment was cleared',
    }),
})
    .pipe(effect_1.Schema.filter(entry => entry.userId === entry.actor.id, {
    message: () => 'userId must equal actor.id',
}))
    .annotations({
    identifier: `${exports.NAMESPACE}.RingAssignment`,
    description: 'A progressive-delivery ring assignment on a device',
});
exports.OperatorAction = effect_1.Schema.Union(exports.RingAssignment).annotations({
    identifier: `${exports.NAMESPACE}.OperatorAction`,
    description: 'An audited operator action, as stored in history_users_api_actions',
});
//# sourceMappingURL=audit.js.map